import { render, staticRenderFns } from "./ContentInvoice.vue?vue&type=template&id=ea89c1fc&"
import script from "./ContentInvoice.vue?vue&type=script&lang=ts&"
export * from "./ContentInvoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports